import { Component, OnInit } from '@angular/core';
import { LearningPath, LEARNING_PATHS } from '../../learning-path';

@Component({
  selector: 'app-learning-paths',
  templateUrl: './learning-paths.component.html',
  styleUrls: ['./learning-paths.component.scss'],
})
export class LearningPathsComponent implements OnInit {
  learningPaths: LearningPath[] = LEARNING_PATHS;

  constructor() {}

  ngOnInit(): void {}

  goTop() {
    window.scrollTo(0,0);
  }
}